import React from 'react';
import { useLocation } from 'react-router-dom';

import FirstScreen from "./components/Home/FirstScreen";
import './Home.css';

export default function Home() {
  const location = useLocation();
  const isHomeRoute = location.pathname === '/';

  return (
    <div className={`wrapper ${!isHomeRoute ? 'vh-height' : ''} ${isHomeRoute ? 'p-0' : ''}`}>
      <FirstScreen />
    </div>
  );
}
